import { MijnRoute } from '../../mijn-navigatie.model';

export const ACCOUNT_OVERVIEW: MijnRoute = {
    path: ':id',
    navigationEvent: 'toRekening',
    regex: /^\/rekening\/[^/]+$/,
    webcomponent: 'mijn-rekening-webcomponent',
    internalPath: ':id'
};
